import imageCompression from "browser-image-compression"

export default {
  data(){
    return {
      imageCompressionOption  : {
        maxSizeMB         : 1,
        maxWidthOrHeight  : 1920,
        useWebWorker      : true
      },

      imageUploadLimit        : 2,

      couldAttachImages       : false,

      inputImagesDataURL      : [],
      inputImagesBlob         : [],

      isImageExecuteRunning   : false
    };
  },

  watch : {
    inputImagesDataURL : {
      handler(data){
        if(data.length >= this.imageUploadLimit){
          this.couldAttachImages = false;
        }else{
          this.couldAttachImages = true;
        }
      },
      immediate : true,
      deep: true,
    },

    inputImagesBlob : {
      handler(data){
        this.$emit('changeImagesBlob', data);
      },
      immediate : true,
      deep: true,
    }
  },

  methods : {
    getImageMBSize(size){
      return (size / 1024 / 1024) + 'Mb';
    },

    isImageBlob(obj){
      return (obj instanceof Blob);
    },

    outputImageFileInfomation(imageFileObject){
      console.log('originalFile instanceof Blob', this.isImageBlob(imageFileObject));
      console.log(`originalFile size ${this.getImageMBSize(imageFileObject.size)}`);
    },

    async imageResize(imageFile){
      if(!this.isImageBlob(imageFile)) return imageFile;

      try {
        return await imageCompression(imageFile, this.imageCompressionOption);
      } catch (error) {
        console.error("getCompressImageFileAsync is error", error);
        // throw error;
        return imageFile;
      }
    },

    handleChangeFileField(event){
      let files = event.target.files || event.dataTransfer.files;
      
      if(typeof files[0] !== 'undefined'){
        this.executeInputImage(files[0]);
      }
    },

    executeInputImage(file){
      this.isImageExecuteRunning = true;

      const reader = new FileReader();

      reader.onload = async (event) => {
        // プレビュー用の画像を先に登録します。
        this.inputImagesDataURL.push(event.target.result);

        const resizedFile = await this.imageResize(this.$refs.imageFileInput.files[0]);

        this.inputImagesBlob.push(resizedFile);

        this.$refs.imageFileInput.value = null;
        
        this.isImageExecuteRunning = false;
      }

      // 入力されたファイルをDATAURLに変換して取得します。
      reader.readAsDataURL(file);
    },

    executeDeleteImage(index){
      if(typeof this.inputImagesDataURL[index] === 'undefined') return;

      this.inputImagesDataURL.splice(index, 1);
      this.inputImagesBlob.splice(index, 1);
    },

    initializeImageUpload(){
      this.inputImagesDataURL = [];
      this.inputImagesBlob    = [];
    }
  }
}